import { combineReducers } from 'redux'
import authReducer from './authReducer'
import signautreReducer from './signautreReducer'
import formReducer from './formReducer'
const rootReducer = combineReducers({
    auth: authReducer,
    signature:signautreReducer,
    form: formReducer
})

export default rootReducer